<template>
  <b-row>
    <b-col cols="12">
      <div>
        <div class="num d-flex align-items-center justify-content-start mb-3">
          <p class="mb-0 font-weight-bold">{{ $t('driverPayInfo.title') }}</p>
        </div>
        <b-row class="switch-row">
          <b-col lg="2" md="3" sm="4" class="text-left mb-2">
            <label>{{ $t('driverPayInfo.sameAsDriver') }}</label>
            <b-form-checkbox
              name="check-button"
              class="switch-drivers"
              v-model="singleDriverPayInfo.same_as_driver"
              switch
              size="lg"
            ></b-form-checkbox>
          </b-col>
        </b-row>

        <hr />

        <b-row>
          <b-col lg="6" md="8" sm="12">
            <b-form class="mb-2">
              <b-form-group :label="$t('driverPayInfo.nameLabel')" class="text-left">
                <b-form-input
                  type="text"
                  v-model="driverPayInfo.name"
                  :placeholder="$t('driverPayInfo.namePlaceholder')"
                  :readonly="singleDriverPayInfo.same_as_driver"
                ></b-form-input>
                <p v-if="errors.name" class="field-error">
                  {{ $t('driverPayInfo.fieldRequired') }}
                </p>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col lg="6" md="8" sm="12">
            <b-form class="mb-2">
              <b-form-group :label="$t('driverPayInfo.taxIdLabel')" class="text-left">
                <b-form-input
                  type="text"
                  v-model="driverPayInfo.tax_id"
                  :placeholder="$t('driverPayInfo.taxIdPlaceholder')"
                  :readonly="singleDriverPayInfo.same_as_driver"
                ></b-form-input>
              </b-form-group>
            </b-form>
          </b-col>

          <b-col lg="3" md="4" sm="12">
            <b-form class="mb-2">
              <b-form-group :label="$t('driverPayInfo.addressLabel')" class="text-left select_arrow">
                <b-form-input
                  type="text"
                  v-model="driverPayInfo.address"
                  :placeholder="$t('driverPayInfo.addressPlaceholder')"
                  :readonly="singleDriverPayInfo.same_as_driver"
                ></b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col lg="2" md="4" sm="12" class="text-left mb-2">
            <b-form class="mb-2">
              <b-form-group :label="$t('driverPayInfo.cityLabel')" class="text-left">
                <b-form-input
                  type="text"
                  v-model="driverPayInfo.city"
                  :placeholder="$t('driverPayInfo.cityPlaceholder')"
                  :readonly="singleDriverPayInfo.same_as_driver"
                ></b-form-input>
              </b-form-group>
            </b-form>
          </b-col>
          <b-col lg="3" md="4" sm="12" class="text-left mb-2">
            <b-form class="mb-2">
              <b-form-group :label="$t('driverPayInfo.stateLabel')" class="text-left">
                <v-select
                  class="bg_white"
                  v-model="driverPayInfo.state"
                  :options="driverStates"
                  :reduce="(option) => option.id"
                  :disabled="singleDriverPayInfo.same_as_driver"
                />
              </b-form-group>
            </b-form>
          </b-col>
          <b-col lg="2" md="4" sm="12" class="text-left mb-2">
            <b-form class="mb-2">
              <b-form-group :label="$t('driverPayInfo.postalCodeLabel')" class="text-left">
                <b-form-input
                  type="text"
                  v-model="driverPayInfo.postal_code"
                  :placeholder="$t('driverPayInfo.postalCodePlaceholder')"
                  :readonly="singleDriverPayInfo.same_as_driver"
                ></b-form-input>
              </b-form-group>
            </b-form>
          </b-col>

          <b-col lg="2" md="4" sm="12" class="text-left mb-2">
            <b-form class="mb-2">
              <b-form-group :label="$t('driverPayInfo.countryLabel')" class="text-left">
                <v-select
                  class="bg_white mb-3"
                  v-model="driverPayInfo.country"
                  :options="countries"
                  :reduce="(option) => option.id"
                  :disabled="singleDriverPayInfo.same_as_driver"
                />
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { mapGetters } from "vuex";
export default {
  name: "DriverPayInfoFields",
  components: {
    vSelect,
  },
  computed: {
    ...mapGetters(["allCountries"]),
  },
  props: [
    "currentTeamMember",
    "countries",
    "states",
    "driverPayInfo",
    "singleDriverPayInfo",
    "errors",
  ],
  data() {
    return {
      // sameAsDriver: true,
      driverStates: this.states,
    };
  },
  methods: {
    getStates(selectedOption, item) {
      this.driverStates = this.allCountries
        .filter((country) => country.id === selectedOption.id)[0]
        .state.map((item) => ({
          id: item.id,
          label: item.name,
        }));
      if (this.driverStates.length === 0) {
        // this.driverPayInfo.state = null;
        this.driverPayInfo.state = this.driverStates.filter(
          (state) => state.label === "-"
        )[0].id;
      } else {
        if (this.driverPayInfo.state && item) {
          this.driverPayInfo.state = item;
        } else if (this.driverPayInfo.state) {
          this.driverPayInfo.state = this.driverStates.filter(
            (state) => state.label === "-"
          )[0].id;
        }
      }
    },
  },

  watch: {
    "singleDriverPayInfo.same_as_driver"(val) {
      this.$emit("sameAsDriverChange", val);
    },
    "driverPayInfo.country"() {
      this.getStates({
        id: this.driverPayInfo.country,
      });
    },
  },
  mounted() {
    this.driverStates = this.states;
  },
};
</script>

<style>
.switch-drivers {
  padding-left: 1.5rem !important;
}
</style>
